import React from 'react';
import './AuthFooter.css';

const AuthFooter = () => {
    return (
        <footer className="auth-footer">
            <p className="auth-footer-text">
                © 2026 JEWELLERS PARADISE. ALL RIGHTS RESERVED.
            </p>
        </footer>
    );
};

export default AuthFooter;

